import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

export default function Portal({ type, children }) {
  const elem = document.getElementById(`${type}-root`);
  return createPortal(children, elem);
}

Portal.propTypes = {
  type: PropTypes.oneOf(['modal', 'toast', 'popup']),
  children: PropTypes.node,
};
